import { isEmpty } from '@ember/utils';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

export function getStructuresFromDates(dateFrom, dateTo, structures) {
  if (isEmpty(structures)) {
    return [];
  }
  let sortedStructures = structures
    .slice()
    .sort((a, b) =>
      (a.effectiveFrom || '').localeCompare(b.effectiveFrom || ''),
    );
  return sortedStructures.reduce((activeStructures, structure) => {
    if (structure.effectiveFrom <= dateFrom) {
      activeStructures[0] = structure;
      return activeStructures;
    }
    if (
      structure.effectiveFrom > dateFrom &&
      structure.effectiveFrom <= dateTo
    ) {
      activeStructures.push(structure);
      return activeStructures;
    }
    return activeStructures;
  }, []);
}

export function isPeriodPresentOnDay(structures, isoDayNumber) {
  return structures.some((structure) => {
    let day = findBy(structure.get('days'), 'isoDayNumber', isoDayNumber);
    return !isEmpty(day) && !isEmpty(day.periodIds);
  });
}
